import type { BasicCustomMailOptionalItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductPlanFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	// チェックイン前7日
	atCheckInBefore_07days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_07daysForText: (value: string) => void;
	onSetAtCheckInBefore_07daysForOverride: (value: boolean) => void;
	onSetAtCheckInBefore_07daysForShouldSendMail: (value: boolean) => void;
	basicAtCheckInBefore_07daysText?: string;
	handleClickedSendTestEmailReservationAtCheckInBefore_00days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	// チェックイン1日前
	atCheckInBefore_01days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_01daysForText: (value: string) => void;
	onSetAtCheckInBefore_01daysForOverride: (value: boolean) => void;
	onSetAtCheckInBefore_01daysForShouldSendMail: (value: boolean) => void;
	basicAtCheckInBefore_01daysText?: string;
	handleClickedSendTestEmailReservationAtCheckInBefore_07days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	atCheckInBefore_00days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	// チェックイン当日
	onSetAtCheckInBefore_00daysForText: (value: string) => void;
	onSetAtCheckInBefore_00daysForOverride: (value: boolean) => void;
	onSetAtCheckInBefore_00daysForShouldSendMail: (value: boolean) => void;
	basicAtCheckInBefore_00daysText?: string;
	handleClickedSendTestEmailReservationAtCheckInBefore_01days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	//
	hotelEmailAddress: string;
	lang: LangCode;
	basicCustomMailSetting: ProductPlanFormModel["QueryData"]["basicCustomMailSetting"];
	title?: string;
	guide?: string;
};

export const ForCheckInEmailTemplates = ({
	isEdited,
	hasError,
	// チェックイン前7日
	atCheckInBefore_07days,
	onSetAtCheckInBefore_07daysForText,
	onSetAtCheckInBefore_07daysForOverride,
	onSetAtCheckInBefore_07daysForShouldSendMail,
	handleClickedSendTestEmailReservationAtCheckInBefore_07days,
	// チェックイン1日前
	atCheckInBefore_01days,
	onSetAtCheckInBefore_01daysForText,
	onSetAtCheckInBefore_01daysForOverride,
	onSetAtCheckInBefore_01daysForShouldSendMail,
	handleClickedSendTestEmailReservationAtCheckInBefore_01days,
	// チェックイン当日
	atCheckInBefore_00days,
	onSetAtCheckInBefore_00daysForText,
	onSetAtCheckInBefore_00daysForOverride,
	onSetAtCheckInBefore_00daysForShouldSendMail,
	handleClickedSendTestEmailReservationAtCheckInBefore_00days,
	//
	hotelEmailAddress,
	lang,
	basicCustomMailSetting,
	title: _title,
	guide: _guide,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"1週間前"}
						dialogTitle={"チェックイン1週間前"}
						textValue={atCheckInBefore_07days?.text.value}
						overrideValue={atCheckInBefore_07days?.override.value}
						shouldSendEmail={atCheckInBefore_07days?.shouldSendEmail.value}
						textErrorMessage={atCheckInBefore_07days?.text.error}
						overrideErrorMessage={atCheckInBefore_07days?.override.error}
						shouldSendEmailErrorMessage={atCheckInBefore_07days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckInBefore_07daysForText}
						handleChangeOverride={onSetAtCheckInBefore_07daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckInBefore_07daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_07days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckInBefore_07days?.override.value}
						onOverrideModeChange={onSetAtCheckInBefore_07daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_07days}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"前日"}
						dialogTitle="チェックイン前日"
						textValue={atCheckInBefore_01days?.text.value}
						overrideValue={atCheckInBefore_01days?.override.value}
						shouldSendEmail={atCheckInBefore_01days?.shouldSendEmail.value}
						textErrorMessage={atCheckInBefore_01days?.text.error}
						overrideErrorMessage={atCheckInBefore_01days?.override.error}
						shouldSendEmailErrorMessage={atCheckInBefore_01days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckInBefore_01daysForText}
						handleChangeOverride={onSetAtCheckInBefore_01daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckInBefore_01daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_01days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckInBefore_01days?.override.value}
						onOverrideModeChange={onSetAtCheckInBefore_01daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_01days}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"当日"}
						dialogTitle="チェックイン当日"
						textValue={atCheckInBefore_00days?.text.value}
						overrideValue={atCheckInBefore_00days?.override.value}
						shouldSendEmail={atCheckInBefore_00days?.shouldSendEmail.value}
						textErrorMessage={atCheckInBefore_00days?.text.error}
						overrideErrorMessage={atCheckInBefore_00days?.override.error}
						shouldSendEmailErrorMessage={atCheckInBefore_00days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckInBefore_00daysForText}
						handleChangeOverride={onSetAtCheckInBefore_00daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckInBefore_00daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_00days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckInBefore_00days?.override.value}
						onOverrideModeChange={onSetAtCheckInBefore_00daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_00days}
					/>
				</div>
			}
		/>
	);
};

ForCheckInEmailTemplates.displayName = "ForCheckInEmailTemplates";
